import type { FC } from 'react';
import React, { memo } from 'react';
import cn from 'classnames';

import { calcPadding, getSources } from './helper';
import type { TProps } from './models';

export const Img: FC<TProps> = memo(
    ({
        // Пустая строка для html5 валидации https://www.w3.org/WAI/tutorials/images/decorative/
        alt = '',
        className,
        dataTestId,
        height,
        images,
        lazy = true,
        radiusKind = 'default',
        responsive = false,
        responsiveDataTestId,
        responsiveKind = 'new',
        src,
        styles,
        width,
    }) => {
        const classNames = cn(
            styles[`${radiusKind}KindRadius`],
            {
                [styles.responsiveImg]: responsive && responsiveKind === 'new',
                [styles.legacyResponsiveImg]: responsive && responsiveKind === 'legacy',
            },
            className
        );
        const responsiveImgContainerProps = responsive
            ? {
                  style: {
                      paddingTop: `calc(${calcPadding(height, width)}%)`,
                  },
              }
            : undefined;

        const sources = images ? getSources(images) : undefined;

        const image = images ? (
            <picture data-test-id={dataTestId}>
                {sources}
                <img
                    alt={alt}
                    className={classNames}
                    height={height}
                    loading={lazy ? 'lazy' : undefined}
                    src={src}
                    width={width}
                />
            </picture>
        ) : (
            <img
                alt={alt}
                className={classNames}
                data-test-id={dataTestId}
                height={height}
                loading={lazy ? 'lazy' : undefined}
                src={src}
                width={width}
            />
        );

        return responsive && responsiveKind === 'new' ? (
            <div
                className={cn({
                    [styles.responsiveImgContainer]: responsive,
                })}
                data-test-id={responsiveDataTestId}
                {...responsiveImgContainerProps}
            >
                {image}
            </div>
        ) : (
            image
        );
    }
);
